import React , { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Axios from '../../../webservice/service';
import classes from './ContactData.module.css';
import Button from '../../../stateless/common/CommonButton/Button';

import Spinner from '../../../stateless/common/Spinner/Spinner';
import Wrapper from '../../../wrapper/Wrapper';
import Input from '../../../stateless/common/Input/Input';

class ContactData extends Component{

    state = {
        inValid : true,
        form : [
            {
                element : 'name',
                elementType : 'input',
                label: 'Name',
                elementConfig : {
                    placeholder : 'Your Name',
                    type : 'text'
                },
                value : '',
                validation : {
                    required : true
                },
                isValid : false,
                isTouched : false
            },
            {
                element : 'email',
                elementType : 'input',
                elementConfig : {
                    placeholder : 'Your E-Mail',
                    type : 'email'
                },
                value : '',
                validation : {
                    required : true
                },
                isValid : false,
                isTouched : false
            },
            {
                element : 'phone',
                elementType : 'input',
                elementConfig : {
                    placeholder : 'Your Phone Number',
                    type : 'text'
                },
                value : '',
                validation : {
                    required : true
                },
                isValid : false,
                isTouched : false
            },
            {
                element : 'street',
                elementType : 'input',
                elementConfig : {
                    placeholder : 'Your Street Address',
                    type : 'text'
                },
                value : '',
                validation : {
                    required : true
                },
                isValid : false,
                isTouched : false
            }
        ],
        ordering : false
    }

    orderHandler = (event) => {
        event.preventDefault();
        this.setState({ordering : true});
        let finalFormValues = {};
        this.state.form.forEach(elements => {
            finalFormValues[elements.element] = elements.value;
        });
        const order = {
            ingredients : this.props.ingredients,
            customer : finalFormValues
        }
        Axios.post('/order.json?auth=' + this.props.token,order)
        .then(() => 
            {
                this.setState({ordering : false});
                this.props.history.push('/orders');
            })
        .catch(error => {
            this.setState({ordering : false});
        });
    }

    validCheck(value , rules){
        let isValid = false;
        if(rules.required){
            isValid = value.trim() !== '';
        }
        return isValid;
    }

    onChangeHandler = (event,index) => {
        let updatedForm = [...this.state.form];
        let getValue = {...updatedForm[index]};
        getValue['value'] = event.target.value;
        getValue['isValid'] = this.validCheck(getValue['value'],getValue['validation']);
        getValue['isTouched'] = true;
        updatedForm[index] = getValue;
        let validArray = updatedForm.filter(value => !value.isValid);
        let invalid = validArray.length > 0;
        this.setState({form:updatedForm , inValid:invalid});
    }

    render(){
        let load = ( 
            <Wrapper>
                <h4 style={{color:'white'}}>Enter you Contact Data</h4>
                <form onSubmit={this.orderHandler}>
                    {
                        this.state.form.map((elements,index) => {
                            return <Input key={elements.element} 
                                elementType={elements.elementType} 
                                elementConfig={elements.elementConfig} 
                                value={elements.value}
                                changed={(event) => this.onChangeHandler(event,index)}
                                required={elements.validation.required}
                                shouldValidate = {elements.validation}
                                isTouched = {elements.isTouched}
                                inValid = {!elements.isValid}
                            />
                        })
                    }
                    <Button type="Success" disabled={this.state.inValid}>Order</Button>
                </form>
            </Wrapper>
            );
        if(this.state.ordering){
            load = <Spinner/>
        }
        return(
            <div className={classes.ContactData}>
                {load}
            </div>
        );
    }
}

export default withRouter(ContactData);